import React from 'react'
import { FormattedMessage,useIntl } from 'react-intl';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import commonFunctions from '../../utils/commonFunctions'
 
function NavbarAccountModal(props) {
  const intl = useIntl();
  const translation = (id) => intl.formatMessage({id})
  const { 
    submitted,
    newEmail, setNewEmail, newEmailValid,
    newPhone, setNewPhone, newPhoneValid,
    error, setError, handleDone
  } = props;

  function handleEmailChange(e) {
    setNewEmail(e.target.value);
  }

  function onClickClose(e) {
    setError('');
  }

  return (
    <div 
      className="modal fade" 
      id="navbarUserModal" 
      tabIndex="-1" 
      aria-labelledby="navbarUserModalLabel" 
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="EDIT_ACCOUNT_INFO" /></h5>
            <button type="button" id="btn-close" className="btn-close" onClick={(e) => onClickClose(e)} data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label htmlFor="email" className="col-form-label"><FormattedMessage id="EMAIL" /><FormattedMessage id="SYMBOL_COLON" /></label>
                <input 
                  className={`form-control ${submitted && !newEmailValid ? "is-valid" : submitted && newEmailValid ? "is-invalid" : ""}`}
                  id="editAccountEmailInput"
                  type="text" 
                  name="email" 
                  onChange={(e) => handleEmailChange(e)} 
                  value={newEmail} 
                />
                {commonFunctions.InvalidFeedbackString(newEmailValid)}
              </div>
              <div className="row">
                <div className="mb-3">
                  <label htmlFor="phone" className="col-form-label"><FormattedMessage id="PHONE" /><FormattedMessage id="SYMBOL_COLON" /></label>
                  <PhoneInput
                    className={`form-control ${submitted && !newPhoneValid ? "is-valid" : submitted && newPhoneValid ? "is-invalid" : ""}`}
                    id="editAccountPhoneInput"
                    placeholder={translation("ENTER_PHONE_NUMBER")}
                    onChange={setNewPhone}
                    value={newPhone}
                  />
                  {commonFunctions.InvalidFeedbackString(newPhoneValid, "PHONE")}
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            {error ? (
              <div className="alert alert-danger"><FormattedMessage id="ERROR" />{error}</div>
            ) : null}
            <button id="saveAccountBtn" type="button" className="btn btn-primary" onClick={handleDone}><FormattedMessage id="DONE_BTN" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavbarAccountModal